import { segPanelId, segTabId } from '@/components/ui/seg-tabs-ids';

import type { NotificationsTab } from './use-url-state';

// Pestañas de la pantalla y sus ids ARIA (tab ↔ tabpanel).

export const TABS: { value: NotificationsTab; label: string }[] = [
  { value: 'avisos', label: 'Mis avisos' },
  { value: 'configuracion', label: 'Configuración' },
];

export const TABS_ID_PREFIX = 'notif';
export const tabId = (t: NotificationsTab): string => segTabId(TABS_ID_PREFIX, t);
export const panelId = (t: NotificationsTab): string => segPanelId(TABS_ID_PREFIX, t);
